<template>
    <div class="page loginRegisterWrapper">
        <div class="image">
          <img src="@/assets/images/M3/logo-smis-gri.svg" alt="" class="login-mobile-logo">
          <LoginRegisterBG></LoginRegisterBG>
        </div>
        <div class="date-user">
            <ForgotPasswordForm></ForgotPasswordForm>
        </div>
    </div>
</template>

<script>
    import ForgotPasswordForm from './componenets/ForgotPasswordForm'
    import LoginRegisterBG from "./componenets/LoginRegisterBG";
    export default {
        name: "Test",
        components: {
            ForgotPasswordForm,
            LoginRegisterBG,
        },
        props: {},
        data() {
            return {};
        },
        created() {},
        methods: {},
    };
</script>

<style scoped>
.page {
    width: 100%;
    display: flex;
    background-color: #fff;
    height: auto;
}
.loginRegisterWrapper {
    position: relative;
}
@media (max-width:1023px) and (min-width:768px){
    .image{
        width: 60%;
    }
}
@media (max-width:841px) {
    .leftNavWrapper .header-container, body{
        overflow: visible;
        height: max-content;
    }
    .contentPage{
        overflow-x: visible;

    }
    .page{
        flex-direction: column;
        padding: 0px 60px;
        height: max-content;
        min-height: 100vh;
    }
    .image{
        width: 100%;
    }
    .date-user{
        width: 100%;
        padding: 0.4rem 0;
        position: absolute;
        bottom:0;
        background: transparent;
    }
}
@media (max-width: 500px) {
      .page {
            padding: 0px 0px;
      }
}
@media screen and (max-width: 700px) and (orientation: landscape) {
    .page {
        height: max-content;
    }
}
</style>
